export const GET_ALL_ADS = "GET_ALL_ADS"
export const EDIT_AD = "EDIT_AD";
export const DELETE_AD = "DELETE_AD";
export const ADD_AD = "ADD_AD";
export const GET_AD_POSITIONS = "GET_AD_POSITIONS";